import { Center } from "@chakra-ui/react"
import { FC } from "react"
import { AdminLoginForm } from "./AdminLoginForm"

export const AdminLogin: FC = () => {
	return (
		<Center>
			<AdminLoginForm />
		</Center>
	)
}
